// Bus antar chart di halaman yang sama. Sengaja NOL IMPORT biar bisa diuji node.

export const HOVER = 'hover';
export const ZOOM = 'zoom';

const channels = {};

export function subscribe(name, fn) {
  if (!channels[name]) channels[name] = [];
  channels[name].push(fn);
  return function unsubscribe() {
    const list = channels[name];
    if (!list) return;
    const i = list.indexOf(fn);
    if (i !== -1) list.splice(i, 1);
  };
}

export function publish(name, value) {
  // Disalin dulu: pelanggan boleh berhenti langganan di dalam handler.
  const list = (channels[name] || []).slice();
  list.forEach((fn) => {
    // Satu chart yang rusak gak boleh nahan chart lain.
    try {
      fn(value);
    } catch (e) {
      console.warn('[chartSync] pelanggan gagal', e);
    }
  });
}

export function clear(name) {
  if (name === undefined) {
    Object.keys(channels).forEach((k) => { delete channels[k]; });
    return;
  }
  delete channels[name];
}
